import React from 'react';
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";
import MotionDivider from "../../../../../ui/MotionDivider";

interface Props {
    order_id?: number,
}

const SchedaCostoSummaryCard = ({order_id: order_id}: Props) => {
    const theme = useTheme();
    const fontSize = 18;


    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);


    return (
        <>
            <Box component="fieldset" sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                border: '1px solid lightgrey',
                borderRadius: '4px',
                padding: '10px',
                backgroundColor: theme.palette.backgroundAppGarageColor.main
            }}>
                <legend style={{
                    padding: '0 8px',
                    color: theme.palette.primary.main,
                    fontWeight: 500
                }}>
                    Riepilogo
                </legend>
                <>

                    <LabelledMuiTypography
                        label={'ORDER ID'}
                        value={detailedObj?.order.order_id ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <MotionDivider/>
                    <LabelledMuiTypography
                        label={'Costo Materia Prima'}
                        value={detailedObj?.total_raw_materials_cost?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Costo Lavorazioni'}
                        value={detailedObj?.total_workings_cost?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Costo Lavorazioni inserite a mano'}
                        value={detailedObj?.total_calculated_cost?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Totale Costi'}
                        value={detailedObj?.total_cost?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Costi al mq'}
                        value={detailedObj?.cost_per_sqm?.toFixed(2) + " €/mq" ?? ''}
                        upperCaseValue={false}
                        fontSize={fontSize}
                    />
                    <MotionDivider/>
                    <LabelledMuiTypography
                        label={'Totale Ricavi'}
                        value={detailedObj?.total_revenue?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />

                    <LabelledMuiTypography
                        label={'Totale Guadagno'}
                        value={detailedObj?.total_profit?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />

                    <LabelledMuiTypography
                        label={'Guadagno al mq'}
                        value={detailedObj?.profit_per_sqm?.toFixed(2) + " €/mq" ?? ''}
                        upperCaseValue={false}
                        fontSize={fontSize}
                    />

                </>

            </Box>

        </>
    );
}

export default SchedaCostoSummaryCard;